import {
  Form, Input, Select, Row, Col,
} from 'antd';
import { func, any } from 'prop-types';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useRequest } from 'ahooks';
import CustomFooter from '@/components/CustomFooter/CustomFooter';
import { addDecimalNum } from '@/utils/utils';
import { getSpecialContentData } from '@/services/agriculturalSubsidies';
import EquipmentList from './EquipmentList';
import { getXmddSpecialContentData } from '@/services/projectScheduling';

const formItemLayout = {
  labelCol: {
    sm: { span: 9 },
  },
};

const formItemLayout1 = {
  labelCol: {
    sm: { span: 4 },
  },
};

/*
* 申请省级资金详细情况表
* */

export default function FundingForm({
  data,
  onOk,
  onCancel,
  dict,
  type, // 项目调度的农产品传type，不显示备注输入项
  parentForm,
}) {
  const [form] = Form.useForm();
  const { run, data: specialContent = [] } = useRequest(getSpecialContentData, { manual: true });
  const { run: run1, data: specialContent1 = [] } = useRequest(getXmddSpecialContentData, { manual: true });
  function onFinish() {
    form.validateFields().then((values) => {
      const equips = values.specialAgriculturalFundsEquips || [];
      const equipsWithTotal = equips.map((item) => {
        const fundingTotal = addDecimalNum(
          [
            item.provincialSubsidyFunds,
            item.cityFunding,
            item.selfFunding,
            item.otherFunding,
          ],
        );

        return {
          ...item,
          fundingTotal, // 每条合计
        };
      });
      // 各类合计
      const totalAmount = addDecimalNum(equipsWithTotal, 'fundingTotal');

      const provincialSubsidyFunds = addDecimalNum(
        equipsWithTotal,
        'provincialSubsidyFunds',
      );

      const cityFunding = addDecimalNum(
        equipsWithTotal,
        'cityFunding',
      );

      const selfFunding = addDecimalNum(
        equipsWithTotal,
        'selfFunding',
      );

      const otherFunding = addDecimalNum(
        equipsWithTotal,
        'otherFunding',
      );
      const params = {
        ...values, totalAmount, provincialSubsidyFunds, cityFunding, selfFunding, otherFunding, rowKey: data?.rowKey,
      };
      onOk(params);
    });
  }

  useEffect(() => {
    if (!isEmpty(data)) {
      const tempData = { ...data };
      if (data?.rowKey && type) {
        const finishFlagList = parentForm.getFieldValue(`specialAgriculturalFundsEquips${data?.rowKey}`) || [];
        const specialAgriculturalFundsEquips = data?.specialAgriculturalFundsEquips || [];
        // 生成新的数组
        const newEquipList = specialAgriculturalFundsEquips.map(
          (item, index) => {
            const finishItem = finishFlagList[index] || {};

            if (finishItem.finishFlag) {
              return {
                ...item,
                equipmentInvestmentCompleted: addDecimalNum([
                  item.provincialSubsidyFunds,
                  item.cityFunding,
                  item.selfFunding,
                  item.otherFunding,
                ]),
              };
            }

            return {
              ...item,
              equipmentInvestmentCompleted: 0,
            };
          },
        );

        // 重新赋值给 data
        tempData.specialAgriculturalFundsEquips = newEquipList;
      }
      form.setFieldsValue(tempData);
      if (data?.projectName) {
        run(data?.projectName);
      }
      if (data?.subProjectCode) {
        run1(data?.subProjectCode);
      }
    }
  }, [data]);

  return (
    <>
      <Form
        {...formItemLayout}
        form={form}
        name="form"
        initialValues={{
          specialAgriculturalFundsEquips: [{}], // 默认一条
        }}
      >
        <Row>
          <Col span={12}>
            <Form.Item
              {...formItemLayout1}
              name="projectName"
              label="子项名称"
              rules={[
                {
                  required: true,
                  message: '请选择子项名称',
                },
              ]}
            >
              <Select
                placeholder="请选择子项名称"
                options={dict?.specialProjectName || []}
                fieldNames={{ label: 'name', value: 'val' }}
                onChange={(value) => {
                  if (type === 2) {
                    run1(value);
                  } else {
                    run(value);
                  }
                  form.setFieldsValue({ constructionContent: undefined });
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...formItemLayout1}
              name="constructionContent"
              label="建设内容"
              rules={[
                {
                  required: true,
                  message: '请输入建设内容',
                },
              ]}
            >
              <Select placeholder="请选择建设内容" options={type === 2 ? specialContent1 : specialContent} fieldNames={{ label: 'name', value: 'name' }} />
            </Form.Item>
          </Col>
        </Row>
        <EquipmentList form={form} rowKey={type ? data?.rowKey : ''} parentForm={parentForm} />
        <Form.Item
          labelCol={{ sm: { span: 2 } }}
          name="remark"
          label="备注"
          hidden={type}
        >
          <Input.TextArea placeholder="请输入备注" showCount maxLength={200} />
        </Form.Item>
      </Form>
      <CustomFooter
        onOk={() => onFinish()}
        onCancel={onCancel}
        confirmLoading={false}
      />
    </>
  );
}

FundingForm.propTypes = {
  data: any,
  onOk: func,
  onCancel: func,
  dict: any,
  type: any,
  parentForm: any,
};
